

















































































































//@ts-nocheck
import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
//@ts-ignore
import municipios from '@/mixins/axios/municipios'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
@Component({
  components: {
    municipios,
    TablePPoa
  },
   mixins: [municipios],
  mounted(){
      this.getData();
this.mapainit();
  },
   data() {
    return {
        latitud:null,
        longitud:null,
        marker:[],
        municipiosdata:[],
        map:null,
         columnasd:[
            
            {
                tag:'select',
                data:'select',
                active:false
            },
            
             {
                tag:'numero',
                data:'numero',
                active:true
            },
             {
                tag:'nombre',
                data:'nombre',
                active:true
            },
              {
                tag:'descripcion',
                data:'descripcion',
                active:true
            },
              {
                tag:'latitud',
                data:'latitud',
                active:false
            },
            {
                tag:'longitud',
                data:'longitud',
                active:false
            }
            ,{
                tag:'contacto',
                data:'contacto',
                active:true
            },
            
        ],
    }
    },
  methods:{
      select(row){
var myLatLng=new google.maps.LatLng( row.latitud,  row.longitud );
          this.map.setCenter(myLatLng);
      },
      async getData() {
   this.$root.$emit('loading', true);
 console.log('loaddding')
let data= await this.GET_MUNICIPIOS().then(response => {

                    if (response != null) {
                        //this.plantas = response;
this.municipiosdata=response;
let th=this;
this.municipiosdata.forEach(element => {
    th.addMarker(element.latitud,element.longitud);
    console.log(element)
});
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");

                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      addMarker(latitud,longitud){

var myLatLng=new google.maps.LatLng( latitud,  longitud );



let mapp= this.map;
console.log(mapp)
let mark=new google.maps.Marker({
    position: myLatLng,
   map:mapp,
    title: "Ubicación",
  });
  this.marker.push(mark);
      },
      mapainit(){
           let map: google.maps.Map;


  map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
    center: { lat: 25.5444, lng: -103.442  },
    zoom: 8,
  });

  
//let th=this;
this.map=map;
//th.addMarker(map);
 /*google.maps.event.addListener(map, "click", (event) => {
console.log(event.latLng);
let data=event.latLng;
     th.latitud=data.lat();
       th.longitud=data.lng();
    th.addMarker(map);
  });*/
  

      },
  }
})
export default class Home extends Vue {}
